/**
 * Angular modules
 */
angular.module('uofa.agentsportal', [
  'ngAnimate',
  'ngCookies',
  'ui.bootstrap',
  'ui.router',
  'angularMoment',
  'angular-loading-bar'
]);

/**
 * Controllers
 */
angular.module('uofa.agentsportal')
  .controller('MasterCtrl', ['$scope', '$cookieStore', MasterCtrl]);

/////////////////////////////// REMOVE ALL BELOW WHEN REFACTORING
// MASTER CONTROLLER
function MasterCtrl($scope, $cookieStore) {

  $scope.angular_datasources = window.angular_datasources;

  /**
   * Sidebar Toggle & Cookie Control
   *
   */
  var mobileView = 992;

  $scope.getWidth = function() { return window.innerWidth; };

  $scope.$watch($scope.getWidth, function(newValue, oldValue)
  {
      if(newValue >= mobileView)
      {
          if(angular.isDefined($cookieStore.get('toggle')))
          {
              if($cookieStore.get('toggle') == false)
              {
                  $scope.toggle = false;
              }
              else
              {
                  $scope.toggle = true;
              }
          }
          else
          {
              $scope.toggle = true;
          }
      }
      else
      {
          $scope.toggle = false;
      }

  });

  $scope.toggleSidebar = function()
  {
      $scope.toggle = ! $scope.toggle;

      $cookieStore.put('toggle', $scope.toggle);
  };

  window.onresize = function() { $scope.$apply(); };
}

angular.module('uofa.agentsportal')
    .run(function($rootScope, $templateCache) {
        $rootScope.$on('$routeChangeStart', function(event, next, current) {
            if (typeof(current) !== 'undefined'){
                $templateCache.remove(current.templateUrl);
            }
        });
    });
